import React, { useState, useEffect } from "react";
import { graphic } from "echarts";
import ECharts, { EChartsReactProps } from "echarts-for-react";
import { useTranslation } from "react-i18next";

const EmergencyDetail = () => {
    const { t } = useTranslation();

    useEffect(() => {}, []);

    // 심박수 컬러
    const heartColor = "#F75C5D";

    // 호흡수 컬러
    const breathColor = "#3889ff";

    // 산소불포화지수 컬러
    const oxygenColor = "#3fd3d4";

    const [options, setOptions] = useState({
        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "cross",
                lineStyle: {
                    color: heartColor,
                    width: 2
                },
                crossStyle: {
                    color: heartColor,
                    width: 2
                }
            },
            animation: true,
            formatter: `{c} BPM`,
            textStyle: {
                color: "black",
                fontWeight: "bold",
                fontFamily: "Pretendard",
                fontSize: 14
            }
        },
        xAxis: {
            boundaryGap: false,
            splitLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            axisLine: {
                lineStyle: {
                    width: 1,
                    color: "#aaaaaa"
                }
            },
            axisLabel: {
                color: "#aaaaaa",
                fontWeight: "bolder",
                fontSize: 14,
                formatter: "{value}\n",
                fontFamily: "Pretendard"
            },
            data: ["오전\n10:40", "오전\n10:40", "오전\n10:40", "오전\n10:40", "오전\n10:40", "오전\n10:40", "오전\n10:40", "오전\n10:40"]
        },
        yAxis: {
            type: "value",
            splitLine: {
                show: false
            },
            axisLabel: {
                color: "#aaaaaa",
                fontWeight: "bolder",
                fontSize: 14,
                formatter: "{value}\n",
                fontFamily: "Pretendard"
            }
        },
        grid: {
            top: 70,
            left: 50,
            right: 20,
            bottom: 40
        },
        series: [
            {
                name: "BPM",
                type: "line",
                smooth: true,
                symbolSize: 10,
                itemStyle: {
                    color: heartColor,
                    borderWidth: 20,
                    borderType: "solid",
                    opacity: 0.9
                },
                lineStyle: {
                    color: heartColor,
                    width: 3
                },
                markPoint: {
                    symbol: "rect",
                    symbolSize: [80, 35],
                    symbolOffset: [0, -30],
                    data: [
                        { type: "max", name: "Max" },
                        { type: "min", name: "Min" }
                    ],
                    label: {
                        color: "#000000",
                        fontWeight: "700",
                        fontSize: 16,
                        formatter: `{c} BPM`,
                        fontFamily: "Pretendard"
                    },
                    itemStyle: {
                        color: "white",
                        borderColor: heartColor,
                        borderWidth: 1,
                        opacity: 0.8
                    }
                },
                areaStyle: {
                    color: new graphic.LinearGradient(0, 0, 0, 1, [
                        {
                            offset: 0,
                            color: heartColor
                        },
                        {
                            offset: 1,
                            color: "#ffffff"
                        }
                    ])
                },
                data: [23, 45, 26, 19, 90, 50, 100, 100]
            }
        ]
    });

    return (
        <main className="sub-contents">
            <section className="sub-top-section"></section>

            <div className="inner">
                <h2 className="sub_title">{t("긴급 알림")}</h2>
                <h3 className="sub_title_sm">Emergency</h3>

                <p className="emergency_sub_tit">{t("긴급 알람 상세 내용")}</p>

                <section className="emergency_detail_wrapper">
                    <div className="detail">
                        <span className="icons circle heart"></span>
                        <p className="cate">{t("비상")}</p>
                        <p className="txt">{t("심박수 이상이 감지되었습니다.")}</p>
                        <p className="date">2023년 06월 20일</p>
                    </div>
                    <div className="ranges">
                        <span className="icons md heart"></span>
                        <span className="txt">{t("심박수 범위")} 118 ~ 121 BPM</span>
                    </div>
                    <div className="infos">
                        <span>
                            {t("심박수 알림 기준 수치 ")}
                            <b>120BPM</b>
                        </span>
                        <em>/</em>
                        <span>
                            {t("데이터 소스")} : <b>HYOSIM-001</b>
                        </span>
                    </div>
                </section>

                <section className="emegency_detail_graph">
                    <ECharts option={options} opts={{ renderer: "svg", width: "auto" }} />
                </section>

                <div className="emergency_adult_wrapper">
                    <h4>{t("성인 활력징후 정상범위")}</h4>
                    <ul className="list">
                        <li>
                            <p className="sbj heart">{t("심박수")}</p>
                            <p className="cont">
                                <b>60-100</b> {t("회")}/{t("분")}
                            </p>
                        </li>
                        <li>
                            <p className="sbj breath">{t("호흡수")}</p>
                            <p className="cont">
                                <b>12-20</b> {t("회")}/{t("분")}
                            </p>
                        </li>
                        <li>
                            <p className="sbj oxygen">{t("산소불포화지수")}</p>
                            <p className="cont">
                                <b>00-00</b> {t("회")}/{t("분")}
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
        </main>
    );
};

export default EmergencyDetail;
